import { Injectable } from '@angular/core';
import {Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import {GlobalConstantsService, onlyKitLevelFields} from '../services/global-constants.service';
import {KitService} from '../services/kit.service';


@Injectable()
export class ElementResolver implements Resolve<any> {

  constructor(
    private globalConstantsService: GlobalConstantsService,
    private kitService: KitService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {


    return Observable.of(this.kitService.find(+route.queryParams['kit'])).flatMap(
      (kit) => {
        return this.globalConstantsService.getAll().flatMap(
              (globalFields) => {
                return Observable.of({
                  kit: kit,
                  kitMetaDataFields: onlyKitLevelFields(globalFields).filter((field: any) => field.kit_id == +route.queryParams['kit'])
                });
              }
            );
        }
    );
  }
}





// WEBPACK FOOTER //
// ./src/app/resolvers/element.resolver.ts